import { render, staticRenderFns } from "./MarineList.vue?vue&type=template&id=84386e7c&"
import script from "./MarineList.vue?vue&type=script&lang=js&"
export * from "./MarineList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports